import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import AboutUs from "./pages/about-us";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Pricing from "./pages/Pricing";
import { testSEO } from "./utils/test-seo";
import Demo from "./pages/Demo";
import DemoSuccess from "./pages/Demo/sucess";
import { useState } from "react";
const App = () => {
  useEffect(() => {
    testSEO();
  }, []);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  return (
    <Layout isCalendarOpen={isCalendarOpen} setIsCalendarOpen={setIsCalendarOpen}>
      <Routes>
        <Route path="/" element={<Home isCalendarOpen={isCalendarOpen} setIsCalendarOpen={setIsCalendarOpen} />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/success" element={<DemoSuccess />} />
      </Routes>
    </Layout>
  );
};

export default App;
